import script from "./CommercialCase.vue?vue&type=script&setup=true&lang=js"
export * from "./CommercialCase.vue?vue&type=script&setup=true&lang=js"

import "./CommercialCase.vue?vue&type=style&index=0&id=33de795b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33de795b"]])

export default __exports__